module.exports = __webpack_public_path__ + "static/media/laravel.23864f10.svg";